var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { staticClass: "mobile-navigation" }, [
    _c("div", { staticClass: "mobile-navigation-container" }, [
      _c("div", { staticClass: "main-menu-region" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "menu-navigation-region" }, [
                  _c(
                    "div",
                    { staticClass: "primary" },
                    [
                      _c("content-creator", {
                        attrs: {
                          settings: _vm.getBlobContents(
                            "fullpage-nav-link-list-1"
                          ),
                          permissions: _vm.contentCreatorPermissions,
                          "is-visible": _vm.editContentCreator,
                          filestore: _vm.fileStore,
                          name: "fullpage-nav-link-list-1",
                          "allowed-widgets": "link-list",
                        },
                        on: {
                          updateBlob: (data) =>
                            _vm.saveBlob("fullpage-nav-link-list-1", data),
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "menu-navigation-region" }, [
                  _c(
                    "div",
                    { staticClass: "primary" },
                    [
                      _c("content-creator", {
                        attrs: {
                          settings: _vm.getBlobContents(
                            "fullpage-nav-link-list-2"
                          ),
                          permissions: _vm.contentCreatorPermissions,
                          "is-visible": _vm.editContentCreator,
                          filestore: _vm.fileStore,
                          name: "fullpage-nav-link-list-2",
                          "allowed-widgets": "link-list",
                        },
                        on: {
                          updateBlob: (data) =>
                            _vm.saveBlob("fullpage-nav-link-list-2", data),
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "4" } }, [
                _c("div", { staticClass: "menu-navigation-region" }, [
                  _c(
                    "div",
                    { staticClass: "primary" },
                    [
                      _c("content-creator", {
                        attrs: {
                          settings: _vm.getBlobContents(
                            "fullpage-nav-link-list-3"
                          ),
                          permissions: _vm.contentCreatorPermissions,
                          "is-visible": _vm.editContentCreator,
                          filestore: _vm.fileStore,
                          name: "fullpage-nav-link-list-3",
                          "allowed-widgets": "link-list",
                        },
                        on: {
                          updateBlob: (data) =>
                            _vm.saveBlob("fullpage-nav-link-list-3", data),
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-menu-region", class: _vm.displayClass },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "footer-menu-region-content" }, [
                  _c(
                    "div",
                    { staticClass: "footer-menu-element" },
                    [
                      _c("content-creator", {
                        attrs: {
                          settings: _vm.getBlobContents(
                            "fullpage-footer-nav-links"
                          ),
                          permissions: _vm.contentCreatorPermissions,
                          "is-visible": _vm.editContentCreator,
                          filestore: _vm.fileStore,
                          name: "fullpage-footer-nav-links",
                          "allowed-widgets": "menu-editor",
                        },
                        on: {
                          updateBlob: (data) =>
                            _vm.saveBlob("fullpage-footer-nav-links", data),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "footer-menu-element" },
                    [
                      _c("footer-social", {
                        attrs: {
                          "social-alignment": _vm.socialAlignment,
                          "social-branding": _vm.socialBranding,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }